import { type z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { makeCursorQuery } from '../../common/cursor-page/cursor-page';
import { NotificationCategorySchema } from '../notification-category/notification-category';

/**
 * The member's own notification list — **cursor**-paginated, not offset.
 *
 * A notification list is a timeline an INSERT walks into: a match arriving
 * between page 1 and page 2 shifts every offset by one, so the member scrolling
 * back sees the same row twice. `cursor-page.ts` explains at length why the
 * cursor is the row's UUIDv7 id rather than a timestamp — a stored timestamp
 * re-emitted through the read pipeline is rounded to the second, so a
 * timestamp cursor re-serves every row from the anchor's own second.
 *
 * `unreadOnly` because the one thing a member does with a notification list
 * after a week away is find what they have not seen.
 */
export const NotificationsListQuerySchema = makeCursorQuery({
  unreadOnly: BooleanParamSchema.optional(),
  category: NotificationCategorySchema.optional(),
});

export type NotificationsListQuery = z.infer<typeof NotificationsListQuerySchema>;
